<template>
    <div class="context common_table_view">
        <div class="header">
            <div class="search search_box">
                <el-form :model="searchForm" inline size="small">
                <el-form-item label="活动名称">
                    <el-input class="width_220"
                              @change="getTableData()"
                              v-model="searchForm.name"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getTableData()"
                               type="primary">搜索</el-button>
                </el-form-item>
                </el-form>
            </div>
            <div class="btn_box">
                <el-button type="primary"
                           plain
                           @click="addActive"
                           size="small">
                    添加活动
                </el-button>
            </div>
        </div>
        <div class="table">
            <el-table :data="tableData"
                      stripe
                      width="100%"
                      height="100%">
                <el-table-column v-for="(item, index) in columnData"
                                 :prop="item.prop"
                                 :label="item.label"
                                 :width="item.width"
                                 :formatter="item.formatter"
                                 :fixed="item.fixed"
                                 show-overflow-tooltip
                                 :key="index"></el-table-column>
                <el-table-column label="图片">
                    <template slot-scope="scope">
                        <el-popover placement="left" width="360" trigger="click">
                            <div class="qrcode" style="height: 110px">
                                <img :src="scope.row.real_img_path"
                                     alt="加载失败"
                                     srcset=""
                                     style="width:100%;height:100%;">
                            </div>
                            <span
                                    slot="reference"
                                    style="cursor: pointer; color: #409EFF"
                            >查看</span>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <!--1 未发布 2 发布 3 下线-->
                        <span class="table_btn"
                              v-if="scope.row.status !== 2"
                              @click="online(scope.row)">
                            <i class="el-icon-edit"></i>
                            发布
                        </span>
                        <span class="table_del_btn"
                              v-if="scope.row.status === 2"
                              @click="downline(scope.row)">
                            <i class="el-icon-edit"></i>
                            下线
                        </span>
                        <span class="table_btn"
                              v-if="scope.row.status !== 2"
                              @click="editRow(scope.row)">
                            <i class="el-icon-edit"></i>
                            编辑
                        </span>
                        <span class="table_del_btn"
                              v-if="scope.row.status !== 2"
                              @click="delRow(scope.row)">
                            <i class="el-icon-delete"></i>
                            删除
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="bottom_page">
            <page-view @getTableList="handleCurrentChange"
                       :currentPage="currentPage"
                       :pageSize="pageSize"
                       :total="total"></page-view>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from "vuex"

    export default {
        name: "tableView",
        data() {
            const showEtype = (row, column, cellValue, index) => {
                const text = cellValue === 'paper' ? '文章' :
                    cellValue === 'video' ? '视频' : '';
                return text
            };
           return {
                searchForm: {
                    name: ''
                },
                tableData: [],
                columnData: [
                    {label: '活动名称', prop: 'activity_name'},
                    {label: '类型', prop: 'etype', formatter: showEtype},
                    // {label: '图片', prop: 'img_path'},
                ],

                total: 0,
                currentPage: 1,
                pageSize: 20,

            }
        },
        computed: {

        },
        mounted() {
            this.getTableData()
        },
        methods: {
            ...mapMutations('manageData', {
                setActiveConfigData: 'setActiveConfigData'
            }),
            handleCurrentChange(val) {
                this.getTableData(val)
            },
            getTableData(v = 1) {
                let params = {
                    page: v,
                    page_size: this.pageSize,
                    name: this.searchForm.name
                };
                this.httpGet('/activity_manage/list', params).then(res => {
                    this.tableData = res.data.data_list;
                    this.total = res.data.total;

                    this.$nextTick(() => {
                        this.currentPage = v
                    })
                });
            },
            addActive() {
                this.setActiveConfigData(null);
                this.$emit('changeTopTab', 'addView')
            },
            editRow(row) {
                this.setActiveConfigData(row);
                this.$emit('changeTopTab', 'addView')
            },
            delRow(row) {
                this.$confirm(`确定要删除${row.activity_name} 这条活动么？`).then(() => {
                    this.httpDel(`/activity_manage/${row.activity_id}`).then(res => {
                        this.$message.success('删除成功');
                        if (this.tableData.length === 1) {
                            let page = this.currentPage === 1 ? 1 : this.currentPage - 1;
                            this.getTableData(page)
                        } else {
                            this.getTableData(this.currentPage)
                        }
                    })
                })
            },

            online(row) {
                let params = {
                    activity_id: row.activity_id,
                    status: 2
                };
                this.httpGet('/activity_manage/publish', params).then(res => {
                    if(res.msg) {
                        this.$message.warning(res.msg);
                        return
                    }
                    this.$message.success('发布成功');
                    this.getTableData(this.currentPage)
                })
            },
            downline(row) {
                let params = {
                    activity_id: row.activity_id,
                    status: 3
                };
                this.httpGet('/activity_manage/publish', params).then(res => {
                    if(res.msg) {
                        this.$message.warning(res.msg);
                        return
                    }
                    this.$message.success('下线成功');
                    this.getTableData(this.currentPage)
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
    }
</style>